import React, { useState } from 'react';
import { Button } from 'theme/Button';
import Icon from 'components/Icon/Icon';
import { ModalWrapper, ModalInner } from './ProductManagerModal.styles';
import { insertDataBlock } from 'megadraft';
import constants from './constants';
import { MD } from '@zendeskgarden/react-typography';

const UploadManagerModal = (props) => {
  const [type, setType] = useState(null);
  const [value, setValue] = useState(null);

  if (!props.isOpen) {
    return null;
  }

  function _onSaveRequest() {
    const data = {
      productMap: value,
      productType: type,
      type: constants.PLUGIN_TYPE,
      display: 'small',
    };
    props.onSaveRequest(data);
  }

  return (
    <ModalWrapper className="table-manager-modal">
      <ModalInner>
        <Icon
          style={{ position: 'absolute', top: '10px', right: '10px' }}
          icon="icon-close"
          buttonStyle
          onClick={props.onCloseRequest}
          fontSize={'15px'}
        />
        {!type ? (
          <InitialActions setType={setType} />
        ) : (
          <div style={{ padding: '20px 0 40px' }}>
            <div>
              <input
                value={value || ''}
                placeholder={`${type} Id`}
                onChange={(e) => setValue(e.currentTarget.value)}
                type="text"
              />
            </div>
            <Button
              onClick={_onSaveRequest}
              primary
              style={{ marginTop: '20px' }}
            >
              Done
            </Button>
          </div>
        )}
      </ModalInner>
    </ModalWrapper>
  );
};

const InitialActions = ({ setType }) => {
  return (
    <div style={{ padding: '20px 0 40px' }}>
      <MD bold style={{ marginBottom: '20px' }}>
        What Type Of Product
      </MD>
      <div>
        <Button
          onClick={() => setType('product')}
          primary
          style={{ marginBottom: '20px' }}
        >
          Product
        </Button>
      </div>
      <div>
        <Button onClick={() => setType('listing')} primary style={{}}>
          Listing
        </Button>
      </div>
    </div>
  );
};

export default UploadManagerModal;
